import { h } from "vue";
import { ElNotification } from "element-plus";
import { faCircleCheck, faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { EventBus, Event } from "@/services/eventBus";

const Icon = defineAsyncComponent(() => import("@/components/basics/Icon.vue"));

const generalConfig = {
  position: "bottom-left",
  duration: 5000,
} as const;

export const showSuccessToast = (message: string) => {
  EventBus.emit({ event: Event.ToastSuccess, data: message });
};

export const showErrorToast = (message: string) => {
  EventBus.emit({ event: Event.ToastError, data: message });
};

export const toasts = {
  install() {
    EventBus.on(Event.ToastError, this.addError);
    EventBus.on(Event.ToastSuccess, this.addSuccess);
  },

  addError(message: string) {
    ElNotification({
      message,
      customClass: "error",
      icon: h(Icon, { icon: faCircleExclamation }),
      ...generalConfig,
    });
  },

  addSuccess(message: string) {
    ElNotification({
      message,
      icon: h(Icon, { icon: faCircleCheck }),
      customClass: "success",
      ...generalConfig,
    });
  },
};
